import { memo } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text,
  Box,
} from '@chakra-ui/react'

interface CancellationPolicyModalProps {
  open: boolean
  handleClose: () => void
}

const CancellationPolicyModal: React.FC<CancellationPolicyModalProps> = ({
  open,
  handleClose,
}) => {
  return (
    <Modal isOpen={open} onClose={handleClose} isCentered size="xs">
      <ModalOverlay />
      <ModalContent maxW="356px">
        <ModalHeader
          borderBottom="none"
          fontFamily="Instrument Serif"
          fontSize="24px"
          fontWeight="400"
          lineHeight="100%"
          pt="20px"
          px="20px"
          pb="8px"
          color="var(--blue-dark)"
        >
          Reminder: Our cancellation policy
        </ModalHeader>
        <ModalCloseButton mt="7px" fontWeight="400" color="#9091A4" />
        <ModalBody px="20px" pb="20px" pt="0">
          <Box width="100%">
            <Text
              fontSize="14px"
              fontWeight="400"
              lineHeight="1.1"
              fontFamily="Inter"
              mb="0"
              color="#1B294D"
            >
              We value our providers&apos; time and kindly ask that all
              appointments be canceled{' '}
              <Box as="b">at least 24 hours in advance</Box>. If you&apos;re
              running late, your provider will wait up to 10 minutes. After 10
              minutes, they&apos;ll mark the appointment as a no-show. A $50 fee
              will apply for missed appointments or late cancellations. Thank
              you for your understanding!
            </Text>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default memo(CancellationPolicyModal)
